import { useDispatch, useSelector } from "react-redux";
import { Button } from "../../components/button/button";
import { Header } from "../../components/header/header";
import { Spring } from "../../components/spring/spring";
import { useAnimatedNavigate } from "../../hooks/useAnimatedNavigate";
import { createUser } from "../../features/userReducer";
import { Policy } from "./policy";
import UserAPI from "../../api/UserAPI";

import styles from "./policy.module.css";


export const UserPolicyPage = () => {
    const navigate = useAnimatedNavigate();
    const dispatch = useDispatch();

    const isUser = useSelector(state => state.status.isUser);

    const onConfirm = () => {
        if (isUser) {
            UserAPI
                .updateDocsAgreement()
                .catch(console.error)
                .then(() => navigate("/"));
        } else {
            dispatch(createUser())
                .then(() => UserAPI.updateDocsAgreement())
                .catch(console.error)
                .then(() => navigate("/"));
        }
    }

    return (
        <div className="page_container">
            <div className="page_content">
                <Header title="Пользовательское соглашение" withData={false} />

                <Policy />

                <Spring />

                <Button
                    className={styles.button}
                    text="Я согласен с политикой"
                    onClick={onConfirm}
                />
            </div>
        </div>
    )
}